export var Stats;
(function (Stats) {
    function bindScope(client) {
        return {
            DownloadLocationStats: client.bindCallable({
                name: 'DownloadLocationStats',
                scope: 'stats',
                path: '/api/stats/download-location-stats',
                method: 'post',
                kind: 'api',
            }),
            DownloadOrganizationStats: client.bindCallable({
                name: 'DownloadOrganizationStats',
                scope: 'stats',
                path: '/api/stats/download-organization-stats',
                method: 'post',
                kind: 'api',
            }),
        };
    }
    Stats.bindScope = bindScope;
})(Stats || (Stats = {}));
//# sourceMappingURL=stats.js.map